import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var StopwatchIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15 2a1 1 0 01-.883.993L14 3h-1v1l-.001.05a9.95 9.95 0 015.074 2.004l.609-.606a1.008 1.008 0 011.421 0 1 1 0 01.078 1.33l-.078.087-.565.563A9.962 9.962 0 0122 14c0 5.523-4.477 10-10 10S2 19.523 2 14c0-5.186 3.948-9.45 9.003-9.95L11 4V3h-1a1 1 0 01-.117-1.993L10 1h4a1 1 0 011 1zm-3 4a8 8 0 110 16 8 8 0 010-16zm4.4 9.1L13 13.4V8c0-.6-.4-1-1-1s-1 .4-1 1v6c0 .4.2.7.6.9l4 2c.1.1.2.1.4.1.4 0 .7-.2.9-.6.2-.4 0-1-.5-1.3z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
StopwatchIcon.isCarinaIcon = true;
export default StopwatchIcon;
